import React from 'react'
import styled from 'styled-components'

const Container = styled.span`
    width: 40px;
    margin: 0 10px;
    height: 20px;
    position: relative;

    > span::before {
        box-shadow: 0 1px 1px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .12);
        background-color: #f2f8fa;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        position: absolute;
        left: 0;
        transition: background-color 250ms cubic-bezier(.55, 0, .1, 1), left 250ms cubic-bezier(.55, 0, .1, 1);
        content: '';
        z-index: 1;
    }

    > input {
        width: 40px;
        height: 20px;
        margin: 0;
        position: absolute;
        opacity: 0;
        z-index: 2;
        cursor: ${props => props.disabled ? 'auto' : 'pointer'};
    }

    > input:indeterminate ~ span::before {
        left: 10px;
        background-color: #a0aeea;
    }

    > input:checked ~ span::before {
        left: 20px;
        background-color: #415dd4;
    }

    > input:checked ~ span::after {
        background-color: #a0aeea;
    }

    > span::after {
        width: 40px;
        height: 14px;
        background-color: rgba(160, 183, 190, .4);
        transition: background-color 250ms cubic-bezier(.55, 0, .1, 1), left 250ms cubic-bezier(.55, 0, .1, 1);
        border-radius: 13px;
        position: absolute;
        display: flex;
        top: 3px;
        content: '';
    }
`

class Toggle extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            value: props.defaultValue
        }
    }

    componentDidMount() {
        this.getState()
    }

    componentDidUpdate(props) {
        if (props.defaultValue !== this.props.defaultValue) {
            this.setState({
                value: this.props.defaultValue
            }, () => this.getState())
        }
    }

    getState() {
        const states = this.switchState(this.state.value)
        this.input.checked = states['checked']
        this.input.indeterminate = states['indeterminate']
    }

    switchState(value) {
        switch(value) {
            case '1':
                return {
                        'indeterminate': false,
                        'checked': true
                    }

            case '0':
                return {
                        'indeterminate': false,
                        'checked': false
                    }

            default:
                return {
                    'indeterminate': true,
                    'checked': false
                }
        }
    }

    handleClick = () => {
        if (!this.props.readonly) {
            this.setState({
                value: this.state.value === '1' ? '0' : this.state.value === '0' ? '' : '1'
            }, () => {
                this.getState()
                this.props.handleUpdateValue(this.state.value, this.props.name)
            })
        }
    }

    render() {
        return (
            <Container disabled={this.props.readonly}>
                <input disabled={this.props.readonly} type="checkbox" ref={el => this.input = el}
                    value={this.state.value}
                    onClick={this.handleClick}
                />
                <span />
            </Container>
        )
    }
}

export default Toggle
